import { render, staticRenderFns } from "./saveModal.vue?vue&type=template&id=c4045de0&scoped=true"
import script from "./saveModal.vue?vue&type=script&lang=js"
export * from "./saveModal.vue?vue&type=script&lang=js"
import style0 from "./saveModal.vue?vue&type=style&index=0&id=c4045de0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4045de0",
  null
  
)

export default component.exports